function handleCommunityHtml() {
    if (!($('.commHTMLOptionsToAttach .summary-edit').html())) {
        $('.commHTMLOptionsToAttach').closest('.row-full').addClass('no-community-html');
    } else if (!!($('.summary-edit .Content img').attr('src'))) {
        $('.summary-edit .Content img').wrap('<div class="img-container" />');
        $('.summary-edit .Content > p > .img-container').unwrap();
        $('.summary-edit .Content > *:not(.img-container)').wrapAll('<div class="text-container" />');
    } else if (!!($('.summary-edit .Content ul li a'))) {
        $('.summary-edit .Content > *:not(ul)').wrapAll('<div class="text-container" />');
    }

    $('.summary-edit .Content .text-container').appendTo($('.summary-edit .Content'));
}

function handleAnnouncements() {
    var announcementsList = $('.HLAnnouncements ul');
    
    // Ensure the list exists and is not already a slick slider to avoid errors
    if (announcementsList.length && !announcementsList.hasClass('slick-initialized')) {
        // Initialize the Slick Slider
        announcementsList.slick({
            arrows: true,
            dots: false,
            autoplay: false,
            nextArrow: '<button type="button" class="slick-arrow next-arrow"><span class="sr-only">Next</span><i class="fa-regular fa-arrow-right"></i></button>',
            prevArrow: '<button type="button" class="slick-arrow prev-arrow"><span class="sr-only">Back</span><i class="fa-regular fa-arrow-left"></i></button>'
        });
        // Handle wrapping the announcement title with its link
        $('.HLAnnouncements ul li').each(function() {
            var self = $(this),
                link = $(self).find('.content-row a[id*="More"]'),
                href = $(link).attr('href'),
                target = $(link).attr('target'),
                rel = $(link).attr('rel'),
                h3 = $(self).find('h3');
            if (!!href) {
                // Check if h3 is not already wrapped in a link to prevent duplicates
                if ($(h3).parent().is('a') === false) {
                     $(h3).wrapInner('<a href="' + href + '" target="' + target + '" rel="' + rel + '" />');
                }
            }
            $(link).remove();
        });
    }
}

function handleSidebarResources() {
    $('.HLMyDocuments .Content ul li').each(function() {
        var self = $(this);

        // handle icons
        var iconContainer = $(self).find('.libListReptEntAttchLble').parent();

        $(iconContainer).prependTo(self);

        $(self).find('.listIconContainer a').contents().unwrap();
        $(self).find('.listIconContainer img').parent().addClass('has-image');

        $(self).find('.listIconContainer').each(function () {
            var container = $(this);

            if (!($(container).find('> *').html())) {
                var text = $(container).text();

                text = $.trim(text);
                $(container).text(text);
            }
        });
    });

}

function handleNewsAndResources() {
    $('.recent-news .HLRecentBlogs ul li, .featured-resources .HLMyDocuments ul li').each(function () {
        var self = $(this);

        handleAjaxCall(self);
    });
}

// --- UPDATED FUNCTIONS FOR ASP.NET AJAX ---
$(function () {
        // Functions to run on initial page load
    handleCommunityHtml();
    handleAnnouncements();
    handleSidebarResources();
    handleNewsAndResources();
    $(document).on('click', '.HLAnnouncements .btn-edit', function() {
        var announcementsList = $('.HLAnnouncements ul');
        
        // If the slider exists and is initialized, unslick it before the postback occurs.
        if (announcementsList.length && announcementsList.hasClass('slick-initialized')) {
            announcementsList.slick('unslick');
        }
    });
    if (window.Sys && Sys.WebForms && Sys.WebForms.PageRequestManager) {
        Sys.WebForms.PageRequestManager.getInstance().add_endRequest(function () {
            handleCommunityHtml();
            handleAnnouncements();
            handleSidebarResources();
            handleNewsAndResources();
        });
    }
});